// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @commons
const RAGoalSummary = require('./RAGoalSummary');

// @constants
const { FIRST_STEP, SECOND_STEP } = require('constants/index');

class RAGoalHiringSummary extends React.Component {
    render() {
        const { immHiringFlowData, immHireManagementPlan } = this.props;

        const goalName = immHiringFlowData.get('name');
        const goalEndOfDate = immHiringFlowData.get('endDate');
        const goalAmount = immHiringFlowData.get('amount');
        const investmentAmount = immHireManagementPlan.getIn([
            'steps',
            FIRST_STEP,
            'investmentAmount',
        ]);
        const iconType = immHiringFlowData.get('type');
        const hasRegularContributionSummary = !!immHireManagementPlan.getIn([
            'steps',
            SECOND_STEP,
            'recurringContributionAmount',
        ]);
        let regularContributionsAmount = false;
        let periodicity = false;
        if (hasRegularContributionSummary) {
            regularContributionsAmount = immHireManagementPlan.getIn([
                'steps',
                SECOND_STEP,
                'recurringContributionAmount',
            ]);
            periodicity = immHireManagementPlan.getIn([
                'steps',
                SECOND_STEP,
                'periodicity',
            ]);
        }

        return (
            <RAGoalSummary
                iconType={iconType}
                goalName={goalName}
                goalEndOfDate={goalEndOfDate}
                investmentAmount={investmentAmount}
                goalAmount={goalAmount}
                regularContributionsAmount={regularContributionsAmount}
                periodicity={periodicity}
            />
        );
    }
}

RAGoalHiringSummary.propTypes = {
    immHireManagementPlan: PropTypes.object.isRequired,
    immHiringFlowData: PropTypes.object.isRequired,
};

module.exports = RAGoalHiringSummary;
